import { observable, action, computed, runInAction } from 'mobx';
import moment from 'moment';
import axios from 'axios';

export class StrategyStore {
    @observable strategies = [];
    @observable xStrategies = [];

    constructor({ rootStore }) {
        this.rootStore = rootStore;
        this.fbAuth = rootStore.fbAuth;
        this.db = rootStore.db;
    }

    @action setStrategies(strategies) {
        this.strategies = strategies;
    }

    @action getStrategies() {
        if (!this.watcher) {
            this.watcher = this.query(strategies => {
                this.setStrategies(strategies);
            });
        }
    }

    @action close() {
        this.watcher && this.watcher();
        this.watcher = null;
    }

    @action async getOdysseyStrategies() {
        const { data } = await axios.get(`${this.rootStore.env.strategiesApi}`, {
            headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
        });

        runInAction(() => {
            this.xStrategies = data;
        });
    }

    async getXStrategy(id) {
        const { data } = await axios.get(`${this.rootStore.env.strategiesApi}${id}`, {
            headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
        });

        return data;
    }

    async createX(strat) {
        return await axios.post(`${this.rootStore.env.strategiesApi}`, strat, {
            headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
        });
    }

    async updateX(id, strategy) {
        return await axios.put(`${this.rootStore.env.strategiesApi}${id}`, strategy, {
            headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
        });
    }

    @action async deleteX(strategy) {
        await axios.delete(`${this.rootStore.env.strategiesApi}${strategy._id}`, {
            headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
        });

        runInAction(() => {
            this.xStrategies = this.xStrategies.filter(s => s._id !== strategy._id);
        });
    }

    create(strat) {
        const currentUser = this.rootStore.fbAuth.currentUser;

        if (!currentUser) return Promise.reject();

        return this.rootStore.db.collection(`/users/${currentUser.uid}/strategies`).add(strat);
    }

    update(id, doc) {
        const currentUser = this.rootStore.fbAuth.currentUser;

        if (!currentUser) return Promise.reject();
        delete doc.id;

        return this.rootStore.db
            .collection(`/users/${currentUser.uid}/strategies`)
            .doc(id)
            .update(doc);
    }

    /**
     * Applies a dirty modification to the store, this is not persisted to the db
     * @param doc
     */
    @action unsavedUpdate(doc) {
        console.log(doc);
        for (let i = 0; i < this.strategies.length; i++) {
            const strat = this.strategies[i];

            if (strat.id === doc.id) {
                this.strategies[i] = doc;
            }
        }
    }

    async clone(strat, isNewType = false) {
        const currentUser = this.rootStore.fbAuth.currentUser;
        let next = { ...strat };
        if (!currentUser) return Promise.reject();
        next.name = `Cloned: ${next.name} - ${moment().format('MMMM Do YYYY, h:mm:ss a')}`;

        if (isNewType) {
            delete next._id;
            return await axios.post(`${this.rootStore.env.strategiesApi}`, next, {
                headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
            });
        }
        delete next.id;
        return this.rootStore.db.collection(`/users/${currentUser.uid}/strategies`).add(next);
    }

    delete(id) {
        const currentUser = this.rootStore.fbAuth.currentUser;

        if (!currentUser) return Promise.reject();
        return this.rootStore.db
            .collection(`/users/${currentUser.uid}/strategies`)
            .doc(id)
            .delete();
    }

    getStrategy(id) {
        return this.strategies.filter(s => s.id === id)[0];
    }

    @computed get buySell() {
        return this.getByType('buy_sell');
    }

    @computed get adca() {
        return this.getByType('adca');
    }

    @computed get art() {
        return this.getByType('art');
    }

    @computed get trigger() {
        return this.getByType('trigger');
    }

    @computed get signal() {
        return this.getByType('signal');
    }

    @computed get odysseyLong() {
        return this.getXByType('odyssey_long');
    }

    @computed get odysseyShort() {
        return this.getXByType('odyssey_short');
    }

    @computed get makoLong() {
        return this.getXByType('mako_long');
    }

    @computed get makoShort() {
        return this.getXByType('mako_short');
    }

    @computed get odysseySignal() {
        return this.getXByType('odyssey_signal');
    }

    getXByType(type) {
        return this.xStrategies.filter(s => s.type === type);
    }

    getByType(type) {
        return this.strategies.filter(s => s.type === type);
    }

    query = cb => {
        const currentUser = this.fbAuth.currentUser;

        return this.db
            .collection(`/users/${currentUser.uid}/strategies`)
            .onSnapshot(function(snapshot) {
                let recordSet = [];
                snapshot.forEach(recordSnapshot => {
                    recordSet.push({ ...recordSnapshot.data(), id: recordSnapshot.id });
                });
                cb(recordSet);
            });
    };
}



// WEBPACK FOOTER //
// ./src/stores/StrategyStore.js